import { gql } from '@apollo/client';
import IconSchema from '@apollo/icons/default/IconSchema.svg';
import {
  AccordionHeader,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AccordionTitle,
  Code,
  Heading,
} from '@apollo/orbit';
import React from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  CompositionBuildInputs,
  CompositionBuildInputsFragment,
} from '../../../shared/buildInputsModal/CompositionBuildInputs';
import {
  FilterBuildInputs,
  FilterBuildInputsFragment,
} from '../../../shared/buildInputsModal/FilterBuildInputs';

export const BuildConfigBuildCheckResultFragment = gql`
  fragment BuildConfigBuildCheckResultFragment on BuildCheckResult {
    id
    # buildPipelineTrack
    ... on CompositionBuildCheckResult {
      compositionPackageVersion
    }
    buildInputs {
      ...CompositionBuildInputsFragment
      ...FilterBuildInputsFragment
    }
  }
  ${CompositionBuildInputsFragment}
  ${FilterBuildInputsFragment}
`;

export function BuildConfig({
  buildResult,
}: {
  buildResult: GraphQLTypes.BuildConfigBuildCheckResultFragment;
}) {
  const buildInputs = buildResult.buildInputs;
  return (
    <AccordionItem>
      <AccordionHeader>
        <AccordionTitle className="flex items-center gap-2">
          <IconSchema /> Build
        </AccordionTitle>
        <AccordionIcon />
      </AccordionHeader>
      {/* The [&&] is a hack to get around orbit automatically removing padding from the accordiant if theres a table inside it. */}
      <AccordionPanel className="space-y-4 [&&]:pt-4">
        {'compositionPackageVersion' in buildResult && (
          <div className="px-6">
            <Heading size="lg" className="mb-2">
              Composition version
            </Heading>
            <Code>{buildResult.compositionPackageVersion}</Code>
          </div>
        )}

        {buildInputs.__typename === 'CompositionBuildInputs' ? (
          <CompositionBuildInputs buildInputs={buildInputs} className="px-6" />
        ) : (
          <FilterBuildInputs buildInputs={buildInputs} />
        )}
      </AccordionPanel>
    </AccordionItem>
  );
}
